var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import constants from '../../../config/constants';
export var PORTAL_PERMISSION_KEY = 'ADMINISTRATOR:PORTAL_SETUP:PORTAL_MGMT';
export var PORTAL_TAB_PERMISSION_KEYS = {
    configurations: "".concat(PORTAL_PERMISSION_KEY, ":CONFIGURATIONS"),
    branding: "".concat(PORTAL_PERMISSION_KEY, ":BRANDING"),
};
export var PORTAL_TAB_ORDER = ['configurations', 'branding'];
export var initialPortalConfig = {
    VendorId: null,
    DealerName: '',
    DealerUrl: '',
    IsCreditAppEnabled: 0,
    IsLOCAppEnabled: 0,
    IsTakeDownAppEnabled: 0,
    IsDORFAppEnabled: 0,
    IsQuoteToolEnabled: 0,
    IsReqDocEnabled: 0,
    IsSendAppEnabled: 0,
    IsActivationCodeEnabled: 0,
    IsMultipleAssetEnabled: 0,
    IsAnalyticsEnabled: 0,
    IsSeasonalPayment: 0,
    IsAppGurSectionRequired: 0,
    IsVinDecoderEnabled: 0,
    IsInsuranceOptionEnabled: 0,
    IsSignUpEnabled: 0,
    DefaultInsuranceConsent: '',
    IsDealerRateAdjustmentEnabled: 0,
    DealerRateAdjustmentType: '',
    defaultActivationCode: '',
    IsDefaultLandingLogo: 0,
    IsDefaultLoginLogo1: 0,
    IsDefaultLoginLogo2: 0,
    IsDefaultLoginBackground: 0,
    FontStyle: '',
    PrimaryThemeColor: '',
    SecondaryThemeColor: '',
    ProgramIds: [],
    RateCard: '',
    FAQ: '',
    LandingLogo: '',
    LandingLogoUrl: '',
    LoginLogo1: '',
    LoginLogo1Url: '',
    LoginLogo2: '',
    LoginLogo2Url: '',
    LoginBackground: '',
    LoginBackgroundUrl: '',
    EmailTemplateLogo: '',
    EmailTemplateLogoUrl: '',
};
export var initialBlobFiles = {
    RateCard: '',
    FAQ: '',
    LoginBackground: '',
    LoginLogo1: '',
    LoginLogo2: '',
    LandingLogo: '',
    EmailTemplateLogo: '',
};
export var initialErrors = {
    defaultActivationCode: '',
    DefaultInsuranceConsent: '',
    DealerRateAdjustmentType: '',
    PrimaryThemeColor: '',
    SecondaryThemeColor: '',
    FieldConfig: '',
};
export var initialCreateErrors = {
    defaultActivationCode: '',
    DefaultInsuranceConsent: '',
    DealerRateAdjustmentType: '',
    FieldConfig: '',
    Name: '',
    Domain: '',
    PortalType: '',
    ProgramIds: '',
};
export var DEFAULT_FONT_STYLE = 'ROBOTO';
export var DEFAULT_PRIMARY_THEME_COLOR = '#000';
export var DEFAULT_SECONDARY_THEME_COLOR = '#8D868B';
export var FIELD_CONFIG_REQUIRED_MESSAGE = 'Fill in the configuration for all three applications before saving.';
export var createPortalDefaults = __assign(__assign({}, initialPortalConfig), { IsActivationCodeEnabled: 1, IsMultipleAssetEnabled: 1, IsAnalyticsEnabled: 1, IsCreditAppEnabled: 1, IsLOCAppEnabled: 1, IsTakeDownAppEnabled: 1, IsDORFAppEnabled: 1, IsQuoteToolEnabled: 1, IsReqDocEnabled: 1, IsSendAppEnabled: 1, IsSeasonalPayment: 1, IsAppGurSectionRequired: 0, IsVinDecoderEnabled: 0, IsInsuranceOptionEnabled: 1, IsSignUpEnabled: 1, FontStyle: DEFAULT_FONT_STYLE, PrimaryThemeColor: DEFAULT_PRIMARY_THEME_COLOR, SecondaryThemeColor: DEFAULT_SECONDARY_THEME_COLOR, IsDefaultLandingLogo: 1, IsDefaultLoginLogo1: 1, IsDefaultLoginLogo2: 1, IsDefaultLoginBackground: 1, Name: '', Domain: '', PortalType: '' });
export var createFieldConfigDefaults = function () { return ({
    nor: { json: __assign({}, constants.NorAppObjJSON) },
    loc: { json: __assign({}, constants.LocAppObjJSON) },
    sch: { json: __assign({}, constants.SchAppObjJSON) },
}); };
export var PORTAL_TYPE_OPTIONS = constants.PortalTypes;
export var URL_PATTERN = /^(ftp|http|https):\/\/[^ "]+$/;
export var BRANDING_ERROR_KEYS = ['PrimaryThemeColor', 'SecondaryThemeColor', 'FontStyle'];
export var CONFIG_PAYLOAD_KEYS = [
    'IsCreditAppEnabled',
    'IsLOCAppEnabled',
    'IsTakeDownAppEnabled',
    'IsDORFAppEnabled',
    'IsQuoteToolEnabled',
    'IsSendAppEnabled',
    'IsReqDocEnabled',
    'IsMultipleAssetEnabled',
    'IsAppGurSectionRequired',
    'IsSignUpEnabled',
    'IsSeasonalPayment',
    'IsDealerRateAdjustmentEnabled',
    'DealerRateAdjustmentType',
    'IsActivationCodeEnabled',
    'defaultActivationCode',
    'IsVinDecoderEnabled',
    'IsAnalyticsEnabled',
    'IsInsuranceOptionEnabled',
    'DefaultInsuranceConsent',
];
export var BRANDING_FIELD_KEYS = [
    'FontStyle',
    'PrimaryThemeColor',
    'SecondaryThemeColor',
    'IsDefaultLandingLogo',
    'IsDefaultLoginLogo1',
    'IsDefaultLoginLogo2',
    'IsDefaultLoginBackground',
];
export var BRANDING_FILE_KEYS = [
    'RateCard',
    'FAQ',
    'LoginBackground',
    'LoginLogo1',
    'LoginLogo2',
    'LandingLogo',
    'EmailTemplateLogo',
];
export var TAB_STATE_KEYS = {
    configurations: __spreadArray(__spreadArray([], CONFIG_PAYLOAD_KEYS, true), ['ProgramIds'], false),
    branding: __spreadArray(__spreadArray(__spreadArray([], BRANDING_FIELD_KEYS, true), BRANDING_FILE_KEYS, true), BRANDING_FILE_KEYS.map(function (key) { return "".concat(key, "Url"); }), true),
};
export var TAB_ERROR_KEYS = {
    configurations: ['defaultActivationCode', 'DefaultInsuranceConsent', 'DealerRateAdjustmentType', 'ProgramIds', 'FieldConfig'],
    branding: BRANDING_ERROR_KEYS,
};
export var HEX_COLOR_PATTERN = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
export var toSixDigitHex = function (hex) {
    return /^#[0-9a-fA-F]{3}$/.test(hex) ? "#".concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]).concat(hex[3]).concat(hex[3]) : hex;
};
export var FONT_OPTIONS = [
    { label: 'Roboto', value: 'ROBOTO' },
    { label: 'Roboto Flex', value: 'Roboto Flex' },
    { label: 'Funnel Sans', value: 'Funnel Sans' },
    { label: 'Open Sans', value: 'Open Sans' },
    { label: 'San Serif', value: 'sans-serif' },
];
export var INSURANCE_OPTIONS = [
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
    { label: 'No Default', value: '2' },
];
export var RATE_TYPE_OPTIONS = [
    { label: 'Markup', value: 'Markup' },
    { label: 'Buydown', value: 'Buydown' },
];
export var APPLICATIONS_GRANTED = [
    { name: 'IsCreditAppEnabled', title: 'Credit Application', description: 'Standard credit application with document upload' },
    { name: 'IsLOCAppEnabled', title: 'Line of Credit Application', description: 'Revolving line of credit for repeat purchases' },
    { name: 'IsTakeDownAppEnabled', title: 'Schedule / Takedown', description: 'Schedule and takedown against an approved line' },
    { name: 'IsDORFAppEnabled', title: 'DORF Application', description: 'Dealer Owned Rental Fleet application' },
];
export var TOOLS_AND_WORKFLOWS = [
    { name: 'IsQuoteToolEnabled', label: 'Quote tool' },
    { name: 'IsSendAppEnabled', label: 'Send Application Link' },
    { name: 'IsReqDocEnabled', label: 'Req Docs' },
    { name: 'IsMultipleAssetEnabled', label: 'Enable Multiple Assets' },
    { name: 'IsAppGurSectionRequired', label: 'Is Guarantor Section Required' },
    { name: 'IsSignUpEnabled', label: 'Enable Sign Up' },
];
export var PRICING_AND_PAYMENTS = [
    { name: 'IsSeasonalPayment', label: 'Enable Seasonal Payment' },
    { name: 'IsDealerRateAdjustmentEnabled', label: 'Enable Markup/Buydown Rate' },
];
export var ACCESS_AND_INTEGRATIONS = [
    { name: 'IsActivationCodeEnabled', label: 'Enable Activation Code' },
    { name: 'IsVinDecoderEnabled', label: 'Enable VIN Decoder' },
    { name: 'IsInsuranceOptionEnabled', label: 'Enable Insurance Integration' },
    { name: 'IsAnalyticsEnabled', label: 'Analytics' },
];
export var FIELD_CONFIG_APPS = [
    { appName: 'Credit Application', key: 'nor' },
    { appName: 'Line of Credit Application', key: 'loc' },
    { appName: 'SCH-TakeDown Application', key: 'sch' },
];
export var LOGO_FIELDS = [
    { name: 'LoginBackground', label: 'Landing Page Background', hint: 'Upload an image within 3:2 aspect ratio for best fit.', defaultFlag: 'IsDefaultLoginBackground', assetNoun: 'background' },
    { name: 'LoginLogo1', label: 'Landing Page Logo', hint: 'Upload an image within 320W x 320H pixels for best fit.', defaultFlag: 'IsDefaultLoginLogo1', assetNoun: 'logo' },
    { name: 'LoginLogo2', label: 'Login Screen Logo', hint: 'Upload an image within 160W x 80H pixels for best fit.', defaultFlag: 'IsDefaultLoginLogo2', assetNoun: 'logo' },
    { name: 'LandingLogo', label: 'Header Logo', hint: 'Upload an image within 160W x 80H pixels for best fit.', defaultFlag: 'IsDefaultLandingLogo', assetNoun: 'logo' },
    { name: 'EmailTemplateLogo', label: 'Email Template Logo', hint: 'Upload an image within 160W x 80H pixels for best fit.' },
];
export var FILE_HINTS = {
    RateCard: 'Upload rate card for the Portal. Supported file format is PDF only.',
    FAQ: 'Upload FAQ for the Portal. Supported file format is PDF only.',
};
export var THEME_HINTS = {
    PrimaryThemeColor: 'Select a color or input a hex code to set the primary color for the header and call-to-action buttons.',
    SecondaryThemeColor: 'Select a color or input a hex code to set the secondary color for the secondary buttons.',
};
export var IMAGE_MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg', 'image/svg+xml'];
export var PDF_MIME_TYPE = 'application/pdf';
export var PDF_FILE_KEYS = ['RateCard', 'FAQ'];
